import { Dispatch, SetStateAction } from 'react';
import { APIProvider, Map } from '@vis.gl/react-google-maps';
import { MapOutline } from 'mdi-material-ui';
import { MuiButton } from '@/components/button/MuiButton';
import {
  ibow2_proto_RequestUser,
  ibow2_proto_RequestUserFavorite,
} from '@/init/swagger';
import { useLogic } from './logic';
import { HospitalMarker } from './HospitalMarker';
import { HospitalListingOutput } from '@/helpers/parseHospitalListings';

type Props = {
  requestUser: ibow2_proto_RequestUser;
  favorites: ibow2_proto_RequestUserFavorite[];
  setFavorites: Dispatch<SetStateAction<ibow2_proto_RequestUserFavorite[]>>;
  listings: HospitalListingOutput[];
  onToggleIsShowMap: () => void;
  mapMarkerPortalOfficeId?: number | null;
  onMarkerClick?: (listingId: number) => void;
};

export const HospitalMap: React.FC<Props> = ({
  requestUser,
  favorites,
  setFavorites,
  listings,
  onToggleIsShowMap,
  mapMarkerPortalOfficeId,
  onMarkerClick,
}) => {
  const { cameraProps, handleCameraChange } = useLogic({
    listings,
  });

  return (
    <APIProvider apiKey={process.env.NEXT_PUBLIC_MAPS_API_KEY as string}>
      <MuiButton
        startIcon={<MapOutline />}
        onClick={onToggleIsShowMap}
        variant="contained"
        sx={{
          m: 0,
          maxHeight: 32,
          display: 'none',
          '@media (max-width: 800px)': {
            display: 'flex',
            margin: '0 auto',
            my: 2,
          },
        }}
      >
        Map表示
      </MuiButton>
      <Map
        {...cameraProps}
        onCameraChanged={handleCameraChange}
        mapId={'station-map'}
      >
        {listings.map((listing) => (
          <HospitalMarker
            key={listing.id}
            requestUser={requestUser}
            favorites={favorites}
            setFavorites={setFavorites}
            listing={listing}
            mapMarkerPortalOfficeId={mapMarkerPortalOfficeId}
            onMarkerClick={onMarkerClick}
          />
        ))}
      </Map>
    </APIProvider>
  );
};
